import { useState } from "react";
import { useFormik } from "formik";
import { useTranslation } from "react-i18next";
import { Label, Button, Input } from "@/components/ui";
import { useCreateRoleMutation, useToast } from "@/hooks";
import { RoleValidationSchema } from "@/shared";
import { DisplayError } from "@/utils";
import { ImportRoleModal } from "./import-role-modal";

type FormRoleProps = {
  handleClose: () => void;
};

type RoleRequestDTO = {
  name: string;
};

export function FormCreateRole({ handleClose }: FormRoleProps) {
  const { t } = useTranslation();
  const { toast } = useToast();
  const [isImportModalOpen, setIsImportModalOpen] = useState(false);

  const initialValues = {
    name: "",
  };

  const { mutateAsync, isLoading } = useCreateRoleMutation();
  const { handleSubmit, getFieldProps, errors, touched, resetForm } = useFormik(
    {
      initialValues,
      validationSchema: RoleValidationSchema(),
      onSubmit: async (values) => {
        handleCreateGroupSubmit(values);
      },
    }
  );

  async function handleCreateGroupSubmit(request: RoleRequestDTO) {
    try {
      await mutateAsync(request, {
        onSuccess: () => {
          toast({
            title: t("LABEL.success"),
            description: t("MESSAGE.created successfully"),
          });
          resetForm();
          handleClose();
        },
        onError: (error) => {
          toast({
            title: t("LABEL.error"),
            description: DisplayError(error, t("MESSAGE.error_message")),
            variant: "destructive",
          });
        },
      });
    } catch (error) {
      toast({
        title: t("LABEL.error"),
        description: DisplayError(error, t("MESSAGE.error_message")),
        variant: "destructive",
      });
    }
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-10 px-4 pb-8">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-semibold text-zinc-700">Novo Cargo</h2>
        <Button
          type="button"
          variant="outline"
          onClick={() => setIsImportModalOpen(true)}
          className="text-sm"
        >
          Importar CSV
        </Button>
      </div>
      <div className="space-y-2">
        <div className="flex flex-col gap-2">
          <Label>{t("LABEL.name")}</Label>
          <Input
            isInvalid={touched.name && errors.name}
            isValid={touched.name && !errors.name}
            {...getFieldProps("name")}
            messageError={errors.name}
          />
        </div>
      </div>
      <Button isLoading={isLoading} className="w-full">
        Criar
      </Button>
      
      <ImportRoleModal
        isOpen={isImportModalOpen}
        onClose={() => setIsImportModalOpen(false)}
        onSuccess={handleClose}
      />
    </form>
  );
}
